import React, { FC } from "react";

import { CustomImageType, InternalType, LinkType } from "@bared/groq";

import { type ComponentProps, type FromSanityGraphQL } from "@ts/components";
import { SectionImage } from "@ts/sanity";
import { useAnalytics } from "@hooks/useAnalytics";

export type ImageProps = ComponentProps &
  FromSanityGraphQL<SectionImage> & {
    imageLink: LinkType | InternalType;
    mobileImageLink: LinkType | InternalType;
  };

export type ImageOutputProps = Omit<ImageProps, "image"> & {
  image: CustomImageType;
};

export const withImage =
  (Component: FC<ImageProps>) =>
  ({ name = "Image", analytics, ...props }: ImageProps) => {
    const { trackPromoImpression, VisibilitySensor } = useAnalytics();
    const { image, mobileImage } = props;
    const imageLink = image && image.imagelink ? image.imagelink[0] : null;
    const mobileImageLink =
      mobileImage && mobileImage.imagelink ? mobileImage.imagelink[0] : null;

    const handleVisibilityChange = (visible: boolean) => {
      if (!visible || !analytics) {
        return;
      }
      trackPromoImpression(analytics);
    };

    Component.displayName = name;

    return (
      <VisibilitySensor onChange={handleVisibilityChange}>
        <Component
          {...props}
          image={image}
          imageLink={imageLink}
          mobileImage={mobileImage}
          mobileImageLink={mobileImageLink}
        />
      </VisibilitySensor>
    );
  };
